module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('ol', _vm._l((_vm.servers), function(server) {
    return _c('li', [_vm._v("\n\n          " + _vm._s(server.name) + "\n          "), _c('ul', [_c('li', [_vm._v("ID: " + _vm._s(server.shortUrl))]), _vm._v(" "), _c('li', [_vm._v("Short name: " + _vm._s(server.short_name))]), _vm._v(" "), _c('li', [_vm._v("IP: " + _vm._s(server.ip) + ":" + _vm._s(server.gamePort))]), _vm._v(" "), (server.ips) ? _c('li', [_vm._v("IP secure: " + _vm._s(server.ips) + ":" + _vm._s(server.gamePort))]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("Stats port: " + _vm._s(server.statPort))])])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Servers\n      "), _c('small', [_vm._v("Informations about servers")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ec163aec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/servers/Data.vue
// module id = 325
// module chunks = 2